import React from 'react'
import { CURRENCY } from '../config/currency';

const ButtonShowcase = () => {
  const [quantities, setQuantities] = React.useState<{ [key: string]: number }>({})

  const handleAdd = (type: string) => {
    setQuantities(prev => ({ ...prev, [type]: 1 }))
  }

  const handleIncrement = (type: string) => {
    setQuantities(prev => ({ ...prev, [type]: (prev[type] || 0) + 1 }))
  }

  const handleDecrement = (type: string) => {
    setQuantities(prev => ({ ...prev, [type]: Math.max(0, (prev[type] || 0) - 1) }))
  }

  const buttonVariants = [
    {
      id: 'elegant',
      name: 'Elegant Blue Gradient',
      className: 'btn-add-elegant',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Clean blue gradient with subtle shine',
      recommended: false
    },
    {
      id: 'subtle',
      name: 'Subtle Gray (Current)',
      className: 'btn-add-subtle',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Matches original theme colors',
      recommended: true
    },
    {
      id: 'premium-dark',
      name: 'Premium Dark',
      className: 'btn-add-premium-dark',
      quantityClass: 'quantity-control-premium',
      btnQuantityClass: 'btn-quantity-premium',
      description: 'Sophisticated dark gradient with depth',
      recommended: true
    },
    {
      id: 'vibrant',
      name: 'Vibrant Purple',
      className: 'btn-add-vibrant',
      quantityClass: 'quantity-control-vibrant',
      btnQuantityClass: 'btn-quantity-vibrant',
      description: 'Eye-catching purple to blue gradient',
      recommended: false
    },
    {
      id: 'warm',
      name: 'Warm Sunset',
      className: 'btn-add-warm',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Pink to red gradient',
      recommended: false
    },
    {
      id: 'nature',
      name: 'Fresh Nature',
      className: 'btn-add-nature',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Green to blue natural gradient',
      recommended: false
    },
    {
      id: 'ocean',
      name: 'Ocean Blue',
      className: 'btn-add-ocean',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Blue to cyan ocean gradient',
      recommended: false
    },
    {
      id: 'luxury',
      name: 'Luxury Gold',
      className: 'btn-add-luxury',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Premium gold to blue gradient',
      recommended: false
    },
    {
      id: 'matte',
      name: 'Matte Finish',
      className: 'btn-add-matte',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Flat matte design with subtle hover',
      recommended: true
    },
    {
      id: 'neumorphic',
      name: 'Neumorphic',
      className: 'btn-add-neumorphic',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Soft 3D appearance',
      recommended: false
    },
    {
      id: 'outline-gradient',
      name: 'Outline Gradient',
      className: 'btn-add-outline-gradient',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Gradient border with fill on hover',
      recommended: false
    },
    {
      id: 'glow',
      name: 'Glow Effect',
      className: 'btn-add-glow',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Glowing purple gradient',
      recommended: false
    },
    {
      id: 'morph',
      name: 'Morphing Gradient',
      className: 'btn-add-morph',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Animated gradient shift',
      recommended: false
    },
    {
      id: 'minimal',
      name: 'Minimal Light',
      className: 'btn-add-minimal',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Very light with border',
      recommended: false
    },
    {
      id: 'soft',
      name: 'Soft Purple',
      className: 'btn-add-soft',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Transparent purple with blur',
      recommended: false
    },
    {
      id: 'glass',
      name: 'Glass Morphism',
      className: 'btn-add-glass',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Frosted glass effect',
      recommended: false
    },
    {
      id: 'apple',
      name: 'Apple Style',
      className: 'btn-add-apple',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'iOS-inspired clean design',
      recommended: true
    },
    {
      id: 'spotify',
      name: 'Spotify Green',
      className: 'btn-add-spotify',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Bold uppercase with green',
      recommended: false
    },
    {
      id: 'material',
      name: 'Material You',
      className: 'btn-add-material',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Google Material Design 3',
      recommended: false
    },
    {
      id: 'retro',
      name: 'Retro Wave',
      className: 'btn-add-retro',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Animated retro gradient',
      recommended: false
    },
    {
      id: 'pastel',
      name: 'Pastel Dream',
      className: 'btn-add-pastel',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Soft pastel gradients',
      recommended: false
    },
    {
      id: 'brutalist',
      name: 'Brutalist',
      className: 'btn-add-brutalist',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Bold with red shadow',
      recommended: false
    },
    {
      id: 'mono',
      name: 'Monochrome',
      className: 'btn-add-mono',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Black to white flip',
      recommended: false
    },
    {
      id: 'gradient-border',
      name: 'Rainbow Border',
      className: 'btn-add-gradient-border',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Animated gradient border',
      recommended: false
    },
    {
      id: 'clay',
      name: 'Soft Clay',
      className: 'btn-add-clay',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: '3D clay morphism',
      recommended: false
    },
    {
      id: 'aurora',
      name: 'Aurora',
      className: 'btn-add-aurora',
      quantityClass: 'quantity-control-container',
      btnQuantityClass: 'btn-quantity-control',
      description: 'Flowing aurora effect',
      recommended: false
    }
  ]

  const checkoutVariants = [
    { name: 'Primary Gradient', className: 'btn-gradient-primary' },
    { name: 'Elegant Blue', className: 'btn-add-elegant px-6 py-3 rounded-lg font-semibold' },
    { name: 'Premium Dark', className: 'btn-add-premium-dark px-6 py-3 rounded-lg font-semibold' },
    { name: 'Apple Style', className: 'btn-add-apple px-6 py-3 rounded-full font-medium' },
    { name: 'Matte Black', className: 'btn-add-matte px-6 py-3 rounded-lg font-semibold' },
    { name: 'Aurora Flow', className: 'btn-add-aurora px-6 py-3 rounded-lg font-semibold' },
  ]

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-2">Button Design System Showcase</h1>
      <p className="text-gray-600 mb-8">Explore different button styles and find the perfect one for your app</p>
      
      {/* Quick Navigation */}
      <div className="mb-8 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
        <h3 className="font-semibold mb-2">⭐ Recommended Options</h3>
        <div className="flex flex-wrap gap-2">
          {buttonVariants.filter(v => v.recommended).map(variant => (
            <span key={variant.id} className="px-3 py-1 bg-blue-100 dark:bg-blue-800/30 rounded-full text-sm">
              {variant.name}
            </span>
          ))}
        </div>
      </div>

      {/* Add to Cart Button Variants */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">Add to Cart Button Styles</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {buttonVariants.map(variant => (
            <div 
              key={variant.id} 
              className={`border rounded-lg p-6 bg-white dark:bg-gray-800 ${
                variant.recommended ? 'ring-2 ring-blue-500' : ''
              }`}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold flex items-center gap-2">
                    {variant.name}
                    {variant.recommended && (
                      <span className="text-xs px-2 py-1 bg-blue-100 dark:bg-blue-800 rounded-full">
                        Recommended
                      </span>
                    )}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{variant.description}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                {quantities[variant.id] === 0 || !quantities[variant.id] ? (
                  <button 
                    className={`${variant.className} btn-size-responsive rounded-full transition-all`}
                    onClick={() => handleAdd(variant.id)}
                  >
                    Add
                  </button>
                ) : (
                  <div className={`${variant.quantityClass} flex items-center rounded-full p-1 gap-1`}>
                    <button 
                      className={`${variant.btnQuantityClass} w-8 h-8 rounded-full flex items-center justify-center`}
                      onClick={() => handleDecrement(variant.id)}
                    >
                      -
                    </button>
                    <span className="w-8 text-center font-medium">{quantities[variant.id]}</span>
                    <button 
                      className={`${variant.btnQuantityClass} w-8 h-8 rounded-full flex items-center justify-center`}
                      onClick={() => handleIncrement(variant.id)}
                    >
                      +
                    </button>
                  </div>
                )}
                
                {/* Price display */}
                <div className="text-lg font-semibold">₹250</div>
                
                {/* Total if quantity > 1 */}
                {quantities[variant.id] > 1 && (
                  <div className="text-sm text-gray-600">
                    Total: {CURRENCY.symbol}{250 * quantities[variant.id]}
                  </div>
                )}
              </div>
              
              {/* Show disabled state */}
              <div className="mt-4 flex items-center gap-2">
                <button 
                  className={`${variant.className} btn-size-responsive rounded-full opacity-50 cursor-not-allowed`}
                  disabled
                >
                  Add
                </button>
                <span className="text-sm text-gray-500">Disabled state</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Checkout Button Variants */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">Checkout Button Styles</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {checkoutVariants.map((variant, index) => (
            <div key={index} className="border rounded-lg p-6 bg-white dark:bg-gray-800">
              <h3 className="text-lg font-semibold mb-4">{variant.name}</h3>
              <div className="space-y-4">
                <button className={`${variant.className} transition-all`}>
                  Checkout (3)
                </button>
                <button className={`${variant.className} opacity-50 cursor-not-allowed`} disabled>
                  Checkout (0)
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Full Menu Item Examples */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">Complete Menu Item Examples</h2>
        <div className="space-y-6">
          {/* Example with Premium Dark */}
          <div className="border rounded-lg p-6 bg-white dark:bg-gray-800">
            <h3 className="text-lg font-semibold mb-4">Premium Dark Style</h3>
            <div className="shadow rounded-lg p-4 flex items-start gap-4 bg-gray-50 dark:bg-gray-900">
              <div className="w-16 h-16 rounded-md bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                <span className="text-2xl">🍕</span>
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-gray-900 dark:text-white">Margherita Pizza</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-1">
                  Fresh mozzarella, tomato sauce, basil leaves on a crispy thin crust
                </p>
                <div className="mt-2 flex items-center gap-3">
                  <span className="text-lg font-semibold">₹350</span>
                  <span className="text-sm text-green-600">Available</span>
                </div>
              </div>
              <div className="flex flex-col items-center gap-2">
                <button className="btn-add-premium-dark btn-size-responsive rounded-full">
                  Add
                </button>
              </div>
            </div>
          </div>

          {/* Example with Matte */}
          <div className="border rounded-lg p-6 bg-white dark:bg-gray-800">
            <h3 className="text-lg font-semibold mb-4">Matte Finish Style</h3>
            <div className="shadow rounded-lg p-4 flex items-start gap-4 bg-gray-50 dark:bg-gray-900">
              <div className="w-16 h-16 rounded-md bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                <span className="text-2xl">🍔</span>
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-gray-900 dark:text-white">Classic Burger</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-1">
                  Juicy beef patty with lettuce, tomato, onion, pickles, and special sauce
                </p>
                <div className="mt-2 flex items-center gap-3">
                  <span className="text-lg font-semibold">₹280</span>
                  <span className="text-sm text-orange-600">Only 3 left</span>
                </div>
              </div>
              <div className="flex flex-col items-center gap-2">
                <button className="btn-add-matte btn-size-responsive rounded-full">
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quantity Control Styles */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">Improved Quantity Control Designs</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {/* Standard with better visibility */}
          <div className="border rounded-lg p-6 bg-white dark:bg-gray-800">
            <h3 className="text-lg font-semibold mb-4">Enhanced Standard (Implemented)</h3>
            <div className="flex items-center gap-4">
              <div className="quantity-control-container flex items-center gap-2">
                <button className="btn-quantity-control w-8 h-8 flex items-center justify-center">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                  </svg>
                </button>
                <span className="quantity-display">3</span>
                <button className="btn-quantity-control w-8 h-8 flex items-center justify-center">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                  </svg>
                </button>
              </div>
              <span className="text-sm text-gray-600">Better contrast & larger icons</span>
            </div>
          </div>

          {/* Pill shaped */}
          <div className="border rounded-lg p-6 bg-white dark:bg-gray-800">
            <h3 className="text-lg font-semibold mb-4">Pill Shaped Alternative</h3>
            <div className="flex items-center gap-4">
              <div className="quantity-control-pill">
                <button className="btn-quantity-control w-8 h-8 flex items-center justify-center rounded-full">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                  </svg>
                </button>
                <span className="quantity-display">3</span>
                <button className="btn-quantity-control w-8 h-8 flex items-center justify-center rounded-full">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                  </svg>
                </button>
              </div>
              <span className="text-sm text-gray-600">Fully rounded container</span>
            </div>
          </div>

          {/* Square buttons */}
          <div className="border rounded-lg p-6 bg-white dark:bg-gray-800">
            <h3 className="text-lg font-semibold mb-4">Square Buttons</h3>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <button className="btn-quantity-square">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                  </svg>
                </button>
                <span className="quantity-display">3</span>
                <button className="btn-quantity-square">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                  </svg>
                </button>
              </div>
              <span className="text-sm text-gray-600">Individual square buttons</span>
            </div>
          </div>

          {/* Comparison of old vs new */}
          <div className="border rounded-lg p-6 bg-white dark:bg-gray-800">
            <h3 className="text-lg font-semibold mb-4">Before vs After</h3>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <span className="text-sm w-16">Before:</span>
                <div className="flex items-center gap-1 bg-gray-100 dark:bg-gray-800 rounded-full p-1">
                  <button className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200">-</button>
                  <span className="w-8 text-center">3</span>
                  <button className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200">+</button>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-sm w-16">After:</span>
                <div className="quantity-control-container flex items-center gap-2">
                  <button className="btn-quantity-control w-8 h-8 flex items-center justify-center">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M20 12H4" />
                    </svg>
                  </button>
                  <span className="quantity-display">3</span>
                  <button className="btn-quantity-control w-8 h-8 flex items-center justify-center">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Side by Side Comparison */}
      <section>
        <h2 className="text-2xl font-semibold mb-6">Quick Comparison</h2>
        <div className="overflow-x-auto">
          <div className="flex gap-4 pb-4">
            <div className="flex-shrink-0 w-64 p-4 border rounded-lg bg-white dark:bg-gray-800">
              <h4 className="font-medium mb-3">Current (Subtle)</h4>
              <button className="btn-add-subtle btn-size-responsive rounded-lg w-full mb-2">Add</button>
              <button className="btn-gradient-primary px-4 py-2 rounded-lg w-full">Checkout</button>
            </div>
            <div className="flex-shrink-0 w-64 p-4 border rounded-lg bg-white dark:bg-gray-800">
              <h4 className="font-medium mb-3">Premium Dark</h4>
              <button className="btn-add-premium-dark btn-size-responsive rounded-lg w-full mb-2">Add</button>
              <button className="btn-add-premium-dark px-4 py-2 rounded-lg font-semibold w-full">Checkout</button>
            </div>
            <div className="flex-shrink-0 w-64 p-4 border rounded-lg bg-white dark:bg-gray-800">
              <h4 className="font-medium mb-3">Matte Finish</h4>
              <button className="btn-add-matte btn-size-responsive rounded-lg w-full mb-2">Add</button>
              <button className="btn-add-matte px-4 py-2 rounded-lg font-semibold w-full">Checkout</button>
            </div>
            <div className="flex-shrink-0 w-64 p-4 border rounded-lg bg-white dark:bg-gray-800">
              <h4 className="font-medium mb-3">Apple Style</h4>
              <button className="btn-add-apple btn-size-responsive rounded-lg w-full mb-2">Add</button>
              <button className="btn-add-apple px-4 py-2 rounded-lg font-semibold w-full">Checkout</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ButtonShowcase